import { breakpoints } from './breakpoints'
import { colors } from './colors'
import { font, FontWeight } from './font'
import { grid } from './grid'
import { media } from './media'
import { sizes } from './size'

export const theme = {
  controls: {
    height: 60,
  },
  breakpoints,
  contentMaxWidth: 1200,
  font,
  fontWeight: FontWeight,
  media,
  colors,
  sizes,
  grid,
}

export type Theme = typeof theme
